import * as React from 'react';
import { IDENTIFICATION_LINK } from './constants';
import { ErrorWrapper } from '../../ErrorWrapper';
import { Link } from '../../../../../../../../common/Link';
import { fairPlayIcon } from '../../../icons';

interface IInitialProps {
  serviceName: string;
  onClickAccept(): void;
}

export const Initial = ({ serviceName }: IInitialProps) => {
  return (
    <ErrorWrapper icon={fairPlayIcon}>
      Услуга {serviceName} доступна только для аккаунтов с{' '}
      <Link href={IDENTIFICATION_LINK} target="_blank" rel="noreferrer">
        идентификацией по документам
      </Link>
      .
    </ErrorWrapper>
  );
};
